<template>
    <div class="header"> 
        <!-- <image src="@/assets/logo.png" ></image> -->
        <div class="left-menu">
            <span @click="menuChange">
                <i v-show="isClickMenu" style="font-size:20px;color:#fff" class="el-icon-s-fold"></i>
                <i v-show="!isClickMenu" style="font-size:20px;color:#fff" class="el-icon-s-unfold"></i>
            </span>&nbsp;
        </div>
        <div class="right-menu">
            <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                青岛奥帆海洋文化旅游区 <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-s-promotion" divided @click.native="logout">
                    退出
                  </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
import {removeToken} from '@/utils/auth'
export default {
    data(){
        return{
            isClickMenu:true
        }
    },
    methods:{
        menuChange(){
            this.isClickMenu = !this.isClickMenu
            this.$bus.$emit('menu',this.isClickMenu)
        },
       
        logout(){
            removeToken()
            this.$router.push('/login')
        }
    }
}
</script>

<style lang="scss" scoped>
.header{
    height: 60px;
    background-color: #213450;
    display: flex;
    justify-content:space-between;
    align-items:center;
    padding: 0 20px;
    
}
.user>* {
        vertical-align: middle;
    }
    .el-dropdown-link {
    cursor: pointer;
    color: #fff;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .demonstration {
    display: block;
    color: #8492a6;
    font-size: 14px;
    margin-bottom: 20px;
  }
</style>